import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/categories/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.categories.list

function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = yield getParams(payload)
        let headers
        if (payload?.pagination['event-id']) {
            headers = {
                'event-id': payload?.pagination['event-id']
            }
        }

        const response = yield axios.get(`/companies/categories`, {
            params,
            headers
        })

        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
